import React from 'react';

const HelpCenterTab = () => {
    return (
        <div className="text-center py-16">
            <i className="fa fa-circle-question text-blue-400 text-6xl mb-4"></i>
            <h3 className='font-bold text-2xl text-gray-800'>Help Center</h3>
            <p className='text-gray-500 mt-2'>Find answers to frequently asked questions.</p>
        </div>
    );
};

export default HelpCenterTab;
